module.exports = __webpack_public_path__ + "static/media/14.13be803d.jpg";